module.exports = __webpack_public_path__ + "img/天小天白衣LOGO.fcb3ebff.jpg";